import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgPdfIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={44}
    height={53}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <g clipPath="url(#pdfIcon_svg__a)">
      <path
        d="M5.96 0C2.95 0 .5 2.458.5 5.475v42.049c0 3.017 2.45 5.475 5.46 5.475h32.073c3.01 0 5.46-2.458 5.46-5.475V12.948s.086-1.012-.352-1.998c-.411-.923-1.081-1.566-1.081-1.566l-.005-.007-7.958-7.824-.013-.014s-.68-.648-1.686-1.082c-1.186-.51-2.409-.456-2.409-.456L30.008 0H5.96Z"
        fill="#FF2116"
      />
      <path
        d="M5.96 1.798h24.048a.92.92 0 0 0 .018 0s.961.01 1.665.312a4.562 4.562 0 0 1 1.163.739l7.938 7.806s.478.506.71 1.027c.187.42.198 1.19.198 1.19a.97.97 0 0 0-.001.038v34.614a3.643 3.643 0 0 1-3.666 3.677H5.96a3.643 3.643 0 0 1-3.666-3.677V5.475A3.643 3.643 0 0 1 5.96 1.798Z"
        fill="#F5F5F5"
      />
      <path
        d="M11.235 31.555c-1.234-1.237.101-2.937 3.726-4.743l2.28-1.136.889-1.95a76.83 76.83 0 0 0 1.62-3.885l.733-1.938-.505-1.434c-.62-1.763-.842-4.413-.448-5.365.533-1.29 2.28-1.158 2.971.225.54 1.08.485 3.037-.155 5.504l-.525 2.023.462.787c.255.433.997 1.46 1.65 2.283l1.229 1.531 1.528-.2c4.854-.635 6.517.445 6.517 1.992 0 1.954-3.812 2.115-7.013-.14-.72-.506-1.215-1.01-1.215-1.01s-2.005.41-2.992.676c-1.02.275-1.528.448-3.02.953 0 0-.525.762-.866 1.317-1.27 2.062-2.753 3.772-3.811 4.394-1.186.696-2.429.744-3.055.116Zm1.937-.693c.694-.43 2.099-2.095 3.07-3.64l.394-.627-1.792.904c-2.768 1.395-4.034 2.71-3.376 3.505.37.447.813.41 1.704-.142Zm17.98-5.06c.679-.476.58-1.437-.187-1.824-.597-.301-1.078-.363-2.63-.34-.953.065-2.486.258-2.745.316 0 0 .842.584 1.216.798.497.285 1.707.814 2.59 1.085.87.267 1.374.24 1.756-.035Zm-7.23-3.012c-.41-.433-1.108-1.336-1.551-2.008-.58-.761-.87-1.298-.87-1.298s-.423 1.365-.77 2.186l-1.084 2.685-.314.61s1.67-.55 2.52-.772c.9-.236 2.726-.596 2.726-.596l-.656-.807Zm-2.329-9.366c.105-.882.15-1.762-.133-2.206-.784-.858-1.73-.142-1.57 1.9.055.686.225 1.86.452 2.583l.414 1.316.291-.99c.16-.546.406-1.717.546-2.604Z"
        fill="#FF2116"
      />
      <path
        d="M13.334 37.286h2.004c.64 0 1.16.061 1.56.184.399.119.735.386 1.007.803.273.412.41.909.41 1.491 0 .535-.111.995-.333 1.38-.22.384-.52.661-.895.832-.371.17-.945.255-1.72.255h-.693V45.4h-1.34v-8.114Zm1.34 1.04v2.83h.664c.593 0 1.002-.111 1.227-.333.23-.222.344-.583.344-1.082 0-.373-.075-.674-.225-.904-.15-.234-.316-.376-.498-.428-.178-.055-.46-.083-.848-.083h-.664Zm4.666-1.04h1.82c.882 0 1.585.156 2.111.47.53.313.93.778 1.198 1.396.273.618.409 1.304.409 2.057 0 .792-.122 1.5-.368 2.122a3.373 3.373 0 0 1-1.114 1.498c-.498.38-1.21.57-2.135.57h-1.92v-8.113Zm1.34 1.076v5.962h.558c.778 0 1.343-.27 1.695-.809.352-.543.528-1.266.528-2.17 0-1.989-.741-2.983-2.223-2.983h-.558Zm5.485-1.076h4.494v1.076h-3.154v2.425h2.525v1.076h-2.525V45.4h-1.34v-8.114Z"
        fill="#2C2C2C"
      />
    </g>
    <defs>
      <clipPath id="pdfIcon_svg__a">
        <path fill="#fff" transform="translate(.5)" d="M0 0h43v53H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgPdfIcon);
export default ForwardRef;
